import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Icon } from '@hey-car/ui';

import { color } from 'app/shared/styles_js/variables';
import { trackAction } from 'app/shared/utils/tracking';
import { getNormalizedNetwork } from 'app/dealer/account/utils';
import { Title } from 'app/shared/components/Title/Title';
import { NavigationPane } from 'app/dealer/shared/components/NavigationPane/NavigationPane';

import { Logo } from './Logo';
import {
  NavBarContainerSt,
  NavItemSt,
  NavItemAnchorSt,
  NavigationSt,
  NavItemTextSt,
  TitleAnchorSt,
  TopNavBarSt,
} from './TopNavBar.css';

const noop = () => {};

export const TopNavBar = ({
  hideTagLine,
  network,
  showAvatar,
  showMenu,
  target,
  dealerLoggedIn,
  openNavMenuClick,
  authorities,
  pathname,
  logout,
  closeOverlay,
}) => {
  const { name } = network;
  const avatarIcon = dealerLoggedIn ? 'logged' : 'avatar';
  const avatarTo = dealerLoggedIn ? '/dealer/dashboard' : '/dealer/login';
  const avatarText = dealerLoggedIn ? (
    <FormattedMessage
      id="app.dealer.shared.TopNavBar.dealerLoggedIn"
      defaultMessage="Händlerbereich"
    />
  ) : (
    <FormattedMessage
      id="app.dealer.shared.TopNavBar.dealerLogin"
      defaultMessage="Händler-Login"
    />
  );
  const tagLine = (
    <FormattedMessage
      defaultMessage="Händlerportal"
      id="app.dealer.shared.TopNavBar.dealerPortal"
    />
  );

  const onAvatarClick = () => {
    if (dealerLoggedIn) {
      trackAction('dealer-dashboard_topnav_click', {
        category: target,
        description: 'user clicks on dealer dashboard button in top nav',
      });
    } else {
      trackAction('dealer-auth_topnav_click', {
        category: target,
        description: 'user clicks on dealer login button in top nav',
      });
    }
  };
  const onMenuClick = e => {
    let navTitleTo = '/dealer/account/branches';
    let navTarget = 'dealer.branches';

    if (target === 'dealer-leads') {
      navTitleTo = '/dealer/leads';
      navTarget = 'dealer.leads';
    }

    e.preventDefault();
    trackAction('menu_topnav_click', {
      category: target,
      description: 'user clicks on menu button in top nav',
    });
    openNavMenuClick({
      title: <Title title={tagLine} to={navTitleTo} />,
      target: 'auth',
      component: (
        <NavigationPane
          authorities={authorities}
          currentPath={pathname}
          logout={logout}
          network={network}
          onNavigationItemClick={closeOverlay}
          target={navTarget}
          userLoggedIn={dealerLoggedIn}
        />
      ),
    });
  };

  return (
    <TopNavBarSt>
      <NavBarContainerSt>
        <TitleAnchorSt href="/">
          <Logo />
          {!hideTagLine && tagLine}
        </TitleAnchorSt>
        <NavigationSt>
          {showMenu && (
            <NavItemAnchorSt
              onClick={onMenuClick}
              href="/"
              data-testid="top-navigation-toggle"
            >
              <Icon icon="menu" iconSize="medium" color={color.white} />
              <NavItemTextSt>{name}</NavItemTextSt>
            </NavItemAnchorSt>
          )}
          {showAvatar && (
            <NavItemSt onClick={onAvatarClick} to={avatarTo}>
              <Icon icon={avatarIcon} iconSize="medium" color={color.white} />
              <NavItemTextSt>{avatarText}</NavItemTextSt>
            </NavItemSt>
          )}
        </NavigationSt>
      </NavBarContainerSt>
    </TopNavBarSt>
  );
};

TopNavBar.propTypes = {
  // functions
  openNavMenuClick: PropTypes.func,
  logout: PropTypes.func,
  closeOverlay: PropTypes.func,

  // properties
  dealerLoggedIn: PropTypes.bool.isRequired,
  hideTagLine: PropTypes.bool,
  network: PropTypes.object,
  showAvatar: PropTypes.bool,
  showMenu: PropTypes.bool,
  target: PropTypes.string.isRequired,
  authorities: PropTypes.arrayOf(PropTypes.string),
  pathname: PropTypes.string,
};

TopNavBar.defaultProps = {
  hideTagLine: false,
  network: getNormalizedNetwork({}),
  showAvatar: false,
  showMenu: false,
  authorities: [],
  pathname: '',
  openNavMenuClick: noop,
  logout: noop,
  closeOverlay: noop,
};
